import Tcb from '@/tcb'
const News = {
  data: () => ({
    loading: true,
    news: [],
    total: 0,
    skip: 0,
    paginationLength: 0,
    pagination: false
  }),
  methods: {
    async input (page) {
      this.skip = page - 1
      await this.getNews()
    },
    async getNews () {
      const limit = 10
      const db = Tcb.database()
      this.loading = true
      this.limit = limit
      try {
        const query = db.collection('article').orderBy('date', 'desc').orderBy('order', 'desc').skip(this.skip * limit).limit(limit)
        const reqArr = [query.get()]
        if (!this.total) {
          reqArr.push(query.count())
        }
        const res = await Promise.all(reqArr)
        if (res[1]) {
          this.total = res[1].total
          if (this.total > this.limit) {
            this.pagination = true
            this.paginationLength = Math.ceil(this.total / 10)
          }
        }
        if (res[0].data.length > 0) {
          this.$set(this.news, this.skip, res[0].data.map(item => {
            const { _id, date, title } = item
            return {
              id: _id,
              date: new Date(date),
              title
            }
          }))
          // console.log(this.news)
        }
      } catch (error) {
        // console.log(error)
      }
      this.loading = false
    },
    newsItemOnClick (item) {
      console.log(item)
      this.$router.push({
        path: `news/${item.id}`
      })
    }
  }
}
const LatestNews = {
  data: () => ({
    latestNews: []
  }),
  methods: {
    async getLatestNews () {
      const limit = 10
      const db = Tcb.database()
      try {
        const query = db.collection('article').orderBy('date', 'desc').limit(limit)
        const res = await query.get()
        if (res.data.length > 0) {
          this.latestNews = res.data.map(item => {
            const { _id, date, title, cover } = item
            return {
              id: _id,
              date: new Date(date),
              imgSrc: cover[0],
              title
            }
          })
        }
      } catch (error) {
        // console.log(error)
      }
    },
    newsItemOnClick (item) {
      console.log(item)
      this.$router.push({
        path: `news/${item.id}`
      })
    }
  }
}
export {
  News,
  LatestNews
}
